import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '../Typography/Typography';
import { CardRoot } from './PricingPlan.style';
import { pricingPlanClasses as classes } from './pricingPlanClasses';

const PricingPlan = forwardRef(
  (
    {
      recommendedText,
      title,
      pricing,
      pricingPer,
      payment,
      totalExtraText,
      description,
      planContent,
      ButtonProps,
      ...rest
    },
    ref
  ) => {
    return (
      <CardRoot
        data-qa-id="pricing-plan"
        recommendedText={recommendedText}
        ref={ref}
        {...rest}>
        {recommendedText && (
          <Typography
            variant="body2"
            weight="bold"
            className={classes.mostPopular}>
            {recommendedText}
          </Typography>
        )}
        <CardContent className={classes.content}>
          {title && (
            <Typography variant="h2" className={classes.title}>
              {title}
            </Typography>
          )}
          {pricing && (
            <div className={classes.pricingContainer}>
              <Typography variant="hero1">{pricing}</Typography>
              {pricingPer && (
                <Typography variant="h2" color="textSecondary">
                  &nbsp;/ {pricingPer}
                </Typography>
              )}
            </div>
          )}
          {payment && (
            <div className={classes.total}>
              <Typography variant="body1">{payment}</Typography>
              {totalExtraText && (
                <Typography variant="body1" weight="bold">
                  &nbsp;| {totalExtraText}
                </Typography>
              )}
            </div>
          )}
          {description && (
            <div className={classes.description}>
              <Typography variant="body1" color="textSecondary">
                {description}
              </Typography>
            </div>
          )}
          {planContent && (
            <div className={classes.planContent}>{planContent}</div>
          )}
        </CardContent>
        {ButtonProps && (
          <CardActions className={classes.action}>
            <Button
              variant="contained"
              size="medium"
              color="primary"
              {...ButtonProps}
            />
          </CardActions>
        )}
      </CardRoot>
    );
  }
);

PricingPlan.propTypes = {
  recommendedText: PropTypes.string,
  title: PropTypes.string,
  pricing: PropTypes.string,
  pricingPer: PropTypes.string,
  payment: PropTypes.string,
  totalExtraText: PropTypes.string,
  description: PropTypes.string,
  planContent: PropTypes.node,
  /**
   * props available in Material's [Button](https://mui.com/material-ui/api/button/) component
   */
  ButtonProps: PropTypes.object
};

PricingPlan.classes = classes;
PricingPlan.displayName = 'PricingPlan';

export default PricingPlan;
